/** Build an assignee object from the logged-in admin (the account manager). */
export const assigneeFromUser = (user = {}) => {
  const email = user.email || '';
  const id = user.id != null ? String(user.id) : '';
  if (!email && !id) return undefined;
  return {
    id,
    firstname: user.firstname || user.first_name || user.name || '',
    lastname: user.lastname || user.last_name || '',
    email
  };
};

/** Build a reporter object from a tenant's primary contact, when available. */
export const reporterFromTenant = (tenant = {}) => {
  const contact = tenant.primary_contact || tenant.contact || {};
  const name =
    contact.name ||
    [contact.firstname || contact.first_name, contact.lastname || contact.last_name]
      .filter(Boolean)
      .join(' ');
  const email = contact.email || tenant.emails?.[0] || tenant.email || '';
  if (!name && !email) return { name: '', email: '' };
  return { name: name || '', email: email || '' };
};
